export const REQUIRED_FIELD_MESSAGE = 'Field is required.'
export const INVALID_EMAIL_MESSAGE = 'Invalid email.'
export const INVALID_PASSWORD_MESSAGE = 'Invalid password.'
export const EMAIL_EXISTS_MESSAGE = 'The email address you entered already is being used.'
